import { COPYRIGHT_ENGLISH } from "../constants.js";
export const ko = {
    "Notice": "Notice",
    "No slots available for the selected period.": "No slots available for the selected period.",
    "welcome_back": "다시 오신 것을 환영합니다",
    "login_subtitle": "계속하려면 로그인하십시오.",
    "login_tos_prefix": "로그인하면 다음 사항에 동의하게 됩니다",
    "terms_of_service": "서비스 약관",
    "help": "도움말",
    "privacy": "개인정보 보호",
    "imprint": "법적 고지",
    "or": "또는",
    "google": "Google",
    "sso_icon_alt": "SSO 아이콘",
    "SSO": "SSO",
    "these_zesty_duck_nudge": "기본 정보",
    "north_least_gopher_burn": "이 약속 유형의 목적은 무엇입니까?",
    "lazy_just_duck_spin": "이벤트 제목",
    "Confirm meeting": "회의 확인",
    "Meeting with {{name}}": "{{name}} 님과의 회의",
    "Daily availability": "일일 가용성",
    "tiny_factual_platypus_pave": "회의는 어디에서 열립니까?",
    "less_equal_octopus_dine": "URL의 사용자 정의 가능한 부분",
    "quiet_male_yak_slurp": "이벤트 슬러그",
    "honest_weak_iguana_rest": "장소",
    "dizzy_quiet_walrus_hush": "멋진-회의",
    "tired_whole_bumblebee_type": "Zoom 회의",
    "these_moving_fox_create": "설명",
    "quaint_known_wasp_view": "최소 며칠 전",
    "pretty_grand_cuckoo_arrive": "이 시간보다 적게 미리 이벤트를 예약할 수 없습니다",
    "slow_maroon_spider_praise": "하루에 이 유형의 최대 이벤트 수",
    "grand_wacky_ox_flow": "하루 최대",
    "left_aloof_stork_leap": "버퍼-전",
    "elegant_early_boar_accept": "이 이벤트는 얼마나 걸립니까?",
    "ideal_this_coyote_inspire": "소요 시간",
    "jumpy_tasty_rook_trust": "소요 시간",
    "real_big_crow_push": "이 이벤트 전 버퍼",
    "mealy_happy_ray_flop": "버퍼 전",
    "close_actual_deer_boil": "버퍼 후",
    "keen_zippy_bulldog_gaze": "이 이벤트 후 버퍼",
    "seemly_fine_octopus_slurp": "가용성",
    "each_awake_tadpole_jest": "이벤트 유형 편집",
    "extra_patient_warbler_praise": "예약할 이벤트가 없습니다",
    "petty_swift_piranha_rise": "이벤트 일정 잡기",
    "broad_close_butterfly_drop": "{{name}} 님과 약속 잡기",
    "weary_known_gazelle_file": "필요한 약속 유형을 선택하고 일정 버튼을 클릭하여 예약하십시오. 내 일정의 사용 가능한 슬롯 목록을 받게 됩니다.",
    "low_clean_haddock_bubble": "내 이벤트 유형",
    "My Event Types": "내 이벤트 유형",
    "pink_trite_ocelot_enrich": "이벤트를 추가하기 전에 먼저 캘린더를 연결해야 합니다!",
    "early_sweet_mantis_peek": "이벤트 유형 추가",
    "deft_suave_bear_pause": "로딩 중",
    "equal_jolly_thrush_empower": " 분",
    "Schedule an appointment": "약속 잡기",
    "heroic_kind_llama_zip": "뒤로",
    "awake_jolly_gazelle_lock": "건너뛰기",
    "whole_acidic_parrot_promise": "약속 예약",
    "clear_close_racoon_pat": "{{value, dateTime}}",
    "cuddly_spare_felix_stir": "단계 {{val}}",
    "extra_misty_panda_grip": "사용자는 이 링크를 사용하여 약속을 예약할 수 있습니다.",
    "sunny_great_halibut_empower": "첫 번째 만들기",
    "create_first_event_type_button": "이벤트 유형",
    "application_title": "Appoint Me",
    "orange_grand_racoon_fall": "{{app_title}} 작동 방식",
    "male_patient_hedgehog_ask": "{{app_title}}는 간단하고 사용하기 쉬운 약속 예약 시스템입니다. 이벤트를 만들고 링크를 공유하여 사용자가 귀하와 약속을 예약할 수 있습니다.",
    "factual_moving_hawk_belong": "{{app_title}}가 약속을 추가하는 곳과 바쁜지 확인하는 곳을 지정하십시오.",
    "step_1_configure_calendars": "단계 1: 캘린더 구성",
    "pink_polite_racoon_earn": "단계 2: 이벤트 만들기",
    "happy_wise_mantis_laugh": "\"사용 가능한 시간을 추가하면 준비가 완료됩니다!\"",
    "careful_misty_bullock_splash": "단계 3: 링크 공유",
    "game_frail_vole_treasure": "완료! 축하합니다!",
    "still_helpful_koala_trust": "사용자가 약속을 예약하면 이벤트가 캘린더에 추가됩니다.",
    "steep_fine_lobster_inspire": "이벤트 유형 저장 실패",
    "best_due_parakeet_zip": "이벤트 유형 생성됨!",
    "happy_caring_fox_spur": "이벤트 저장됨",
    "tasty_witty_stingray_hope": "이벤트 저장 오류",
    "trite_warm_gorilla_pet": "캘린더에 약속 추가",
    "aware_alert_mare_glow": "캘린더에서 빈 시간 확인",
    "factual_nimble_snail_clap": "변경 사항 저장",
    "tiny_teary_clownfish_vent": "취소",
    "lower_born_finch_dash": "Google에서 연결 해제",
    "whole_formal_liger_rise": "Google Calendar 연결",
    "pink_loose_cougar_grin": "내 캘린더",
    "upper_even_florian_peek": "Google Calendar",
    "merry_north_meerkat_cuddle": "구성",
    "big_known_loris_revive": "바쁜 시간을 확인할 캘린더를 선택하십시오.",
    "large_suave_gull_hush": "링크 복사",
    "misty_proud_mallard_assure": "링크 복사",
    "teal_lofty_hawk_peek": "취소",
    "mild_raw_elk_delight": "변경 사항 저장",
    "Choose date": "날짜 선택",
    "Please select a date": "날짜를 선택해주세요",
    "Choose time": "시간 선택",
    "Provide details": "세부 정보 제공",
    "Confirmation": "확인",
    "Please share anything that will help me to prepare for our meeting": "회의 준비에 도움이 될 만한 내용을 공유해 주세요",
    "confirmationText_male": "{{date}} {{time}}에 {{name}} 님과 {{event}} 약속을 예약했습니다.",
    "confirmationText_female": "{{date}} {{time}}에 {{name}} 님과 {{event}} 약속을 예약했습니다.",
    "confirmationText_neuter": "{{date}} {{time}}에 {{name}} 님과 {{event}} 약속을 예약했습니다.",
    "Name": "이름",
    "Please provide your name": "이름을 제공해 주세요",
    "Email": "이메일",
    "Information": "정보",
    "You will receive a confirmation email": "확인 이메일을 받게 됩니다",
    "Meeting with": "회의",
    "Change": "변경",
    "Back": "뒤로",
    "Add Event Type": "이벤트 유형 추가",
    "Confirm & Book": "확인 및 예약",
    "availableSlots": "{{date}}에 다음 슬롯을 사용할 수 있습니다. 하나를 예약하거나 다른 날을 선택하십시오.",
    "minutes": "분",
    "Days": "일",
    "Maximum days in advance": "최대 며칠 전",
    "event_advance_availability_description": "이 이벤트 유형은 며칠 전에 사용할 수 있습니까?",
    "none": "없음",
    "Select buffer": "버퍼 선택",
    "Save": "저장",
    "Select duration": "소요 시간 선택",
    "Starttime": "시작 시간",
    "Endtime": "종료 시간",
    "Add Account": "계정 추가",
    "Add CalDav Account": "CalDav 계정 추가",
    "CalDav Accounts": "CalDav 계정",
    "Server URL": "서버 URL",
    "Username": "사용자 이름",
    "label_password": "비밀번호",
    "send_invitation_email": "Send invitation email",
    "send_invitation_email_notice": "Only needed if your CalDAV server does not send invitations automatically.",
    "invitationSubject": "초대: {{summary}}",
    "invitationBody": "<p>안녕하세요 {{attendeeName}} 님,</p><p>다음 이벤트에 초대되었습니다:</p><h3>{{summary}}</h3><p>{{description}}</p><p><strong>시간:</strong> {{time}}</p><p>첨부된 이벤트 세부 정보를 확인하십시오.</p>",
    "icsDescription": "이벤트 설명:\n{{description}}",
    "dateFormat": "ko-KR",
    "user_menu_log_out": "Log out",
    "user_menu_log_in": "Log in",
    "user_menu_profile": "Profile",
    "user_menu_my_account": "My account",
    "user_menu_calendar_integration": "Calendar Integration",
    "user_menu_copy_link": "Copy your link",
    "user_menu_link_copied": "Link copied",
    "name": "이름",
    "user_url": "사용자 URL",
    "use_gravatar": "Gravatar 사용",
    "save": "저장",
    "profile_updated": "프로필이 성공적으로 업데이트되었습니다",
    "error_saving_profile": "프로필 저장 오류",
    "user_url_taken": "사용자 URL이 이미 사용 중입니다",
    "error_loading_profile": "프로필 로드 오류",
    "login_with_sso": "SSO로 로그인",
    "login_with": "로그인",
    "login_successful": "로그인 성공",
    "login_failed": "로그인 실패",
    "google_login_failed": "Google 로그인 실패",
    "Add": "추가",
    "edit": "편집",
    "Close": "닫기",
    "Choose calendars in which appointments are created.": "약속이 생성될 캘린더를 선택하십시오.",
    "Email (Optional)": "이메일 (선택 사항)",
    "Enter your CalDav server details to connect your calendar.": "캘린더를 연결하려면 CalDav 서버 세부 정보를 입력하십시오.",
    "Failed to add account. Please check your credentials and server URL.": "계정을 추가하지 못했습니다. 자격 증명 및 서버 URL을 확인하십시오.",
    "I acknowledge that my password will be stored encrypted in the database.": "내 비밀번호가 데이터베이스에 암호화되어 저장된다는 것을 인정합니다.",
    "event_copy_link": "링크 복사",
    "link_copied_to_clipboard": "링크가 클립보드에 복사되었습니다!",
    "link_copy_failed": "클립보드에 링크를 복사할 수 없습니다!",
    "copy": "복사",
    "Availability Mode": "가용성 모드",
    "Define Custom": "사용자 정의",
    "Use Standard": "표준 사용",
    "Standard + Extra": "표준 + 추가",
    "Standard + Constraints": "표준 + 제한",
    "Standard Availability": "표준 가용성",
    "Using Standard Availability defined in Profile settings.": "프로필 설정에 정의된 표준 가용성을 사용합니다.",
    "Define your standard weekly availability here. You can use this availability in your Event Types.": "여기서 표준 주간 가용성을 정의하세요. 이 가용성을 이벤트 유형에서 사용할 수 있습니다.",
    "Copy Standard Availability": "표준 가용성 복사",
    "Overwrite current availability with standard?": "현재 가용성을 표준으로 덮어쓰시겠습니까?",
    "Profile": "프로필",
    "about": "소개",
    "about_content": "# AppointMe 소개\n\nAppointMe는 일정을 예약하기 위한 간단한 도구입니다.\n달력을 구성하고 가용성을 설정하여 다른 사람들이 귀하와 약속을 예약할 수 있도록 하세요.\n\n## Github\n[Github에서 코드 확인하기](https://github.com/fhswf/appointme)\n\n## 크레딧\nSouth Westphalia University of Applied Sciences에서 ❤️로 구현됨",
    "legal": "법적 고지",
    "Calendar": "캘린더",
    "Select a calendar": "캘린더 선택",
    "No calendar selected": "선택된 캘린더 없음",
    "Calendar settings saved": "캘린더 설정 저장됨",
    "Failed to save settings": "설정 저장 실패",
    "Failed to load calendars for": "캘린더 로드 실패",
    "Google Calendar disconnected": "Google 캘린더 연결 해제됨",
    "Failed to disconnect Google Calendar": "Google 캘린더 연결 해제 실패",
    "Connect a calendar to get started": "시작하려면 캘린더를 연결하세요",
    "Online via Zoom": "Zoom을 통한 온라인",
    "Language": "언어",
    "page not found": "페이지를 찾을 수 없음",
    "GO HOME": "홈으로 이동",
    "Impressum": "법적 고지",
    "Datenschutzhinweise": "개인정보 처리방침",
    "privacy_content": `
# 개인정보 처리방침

## 데이터 수집 및 사용
이 애플리케이션은 약속 예약 서비스를 제공하기 위해 개인 데이터를 수집하고 사용합니다.

*   **사용자 프로필:** 귀하를 식별하고 경험을 개인화하기 위해 귀하의 이름, 이메일 주소 및 프로필 사진을 저장합니다.
*   **Google 사용자 데이터:** Google 캘린더를 연결하면 다음과 같은 목적으로 캘린더 데이터에 액세스합니다.
    *   이중 예약을 방지하기 위해 가용성을 확인합니다.
    *   약속이 예약될 때 캘린더에 새 이벤트를 만듭니다.
    *   Google 캘린더 데이터를 광고나 시장 조사와 같은 다른 목적으로 사용하지 **않습니다**.
*   **캘린더 데이터:** 연결된 캘린더에 대한 구성 설정, 생성한 이벤트 유형(이름, 설명, 위치) 및 약속 예약을 저장합니다.
*   **로그 데이터:** 보안 및 문제 해결을 위해 귀하의 IP 주소는 서버 로그 파일에 임시로 저장됩니다.
*   **텔레메트리:** 애플리케이션 안정성을 개선하기 위해 Sentry를 사용하여 익명의 사용 데이터 및 오류 보고서를 수집합니다.

## 데이터 공유
서비스를 제공하는 데 필요하거나 법률에 의해 요구되는 경우를 제외하고는 귀하의 개인 데이터를 제3자와 공유하지 않습니다.

*   **Google 사용자 데이터:** Google API에서 얻은 데이터는 캘린더 통합 기능(예: Google 서버와의 통신)을 제공하는 데 필요한 경우를 제외하고는 제3자 도구, AI 모델 또는 외부 엔터티와 **공유되지 않습니다**.
*   **서비스 제공업체:** 서비스 안정성을 보장하기 위해 오류 추적 및 애플리케이션 모니터링에 Sentry를 사용합니다. 이 제공업체는 서비스 제공을 위해 IP 주소 및 기타 기술 데이터를 엄격하게 처리할 수 있습니다.
*   **호스팅:** 애플리케이션은 자체 인프라(Kubernetes 클러스터)에서 호스팅됩니다. 따라서 데이터에 액세스할 수 있는 제3자 CDN이나 호스팅 제공업체는 사용하지 않습니다.

## 데이터 저장 및 보호
귀하의 데이터는 당사 서버에 안전하게 저장됩니다.
*   **암호화:** 브라우저와 당사 서버 간에 전송되는 모든 데이터는 HTTPS를 사용하여 암호화됩니다. 액세스 토큰과 같은 민감한 데이터는 데이터베이스에 암호화되어 저장됩니다.
*   **액세스 제어:** 귀하의 데이터에 대한 액세스는 승인된 담당자로 제한되며 지원 또는 유지 관리에 필요한 경우에만 액세스됩니다.

## 데이터 보존 및 삭제
*   **보존:** 귀하의 계정이 활성 상태인 동안 사용자 프로필 및 캘린더 구성 데이터를 보존합니다. 약속 데이터는 예약된 이벤트의 기록을 제공하기 위해 보존됩니다.
*   **삭제:** 귀하는 데이터 삭제를 요청할 권리가 있습니다. 애플리케이션 설정을 통해 언제든지 Google 캘린더 연결을 해제할 수 있으며, 이렇게 하면 Google 데이터에 대한 액세스 권한이 제거됩니다. 계정 및 데이터를 완전히 삭제하도록 요청하려면 gawron.christian@fh-swf.de로 문의하거나 프로필 설정의 계정 삭제 기능을 사용하십시오.

## Google API 서비스 사용자 데이터 정책
Google API에서 받은 정보를 AppointMe가 다른 앱으로 사용 및 전송하는 것은 제한된 사용 요구 사항을 포함하여 [Google API 서비스 사용자 데이터 정책](https://developers.google.com/terms/api-services-user-data-policy)을 준수합니다.`,
    "privacy_content_public": `
# 개인정보 처리방침

## 데이터 처리

약속 예약을 목적으로 이 애플리케이션은 귀하가 제공한 데이터(이름, 이메일 주소, 설명, 약속 날짜 및 시간)를 처리합니다. 이 데이터는 약속을 관리하기 위해 저장되며 주최자의 캘린더와 동기화될 수 있습니다.

## 텔레메트리

애플리케이션 안정성을 개선하기 위해 Sentry를 사용하여 익명의 텔레메트리 데이터 및 오류 보고서를 수집합니다.`,
    "impressum_content": "# 법적 고지\n\n## 면책 조항\n이 서버의 콘텐츠는 사우스 웨스트팔리아 응용과학대학의 공식 온라인 제공물의 일부가 아닙니다.",
    "CalDav Calendar": "CalDav 캘린더",
    "loading": "로딩 중...",
    "Legal": "법적 고지",
    "new_event_type": "새 이벤트 유형",
    "Appointment Summary": "약속 요약",
    "Could not book event": "이벤트를 예약할 수 없음",
    "error_no_calendar": "캘린더 통합이 구성되지 않음",
    "error_no_duration": "기간은 0보다 커야 함",
    "error_no_slots": "구성된 시간 슬롯 없음",
    "Active": "활성",
    "Inactive": "비활성",
    "delete": "삭제",
    "Continue": "계속",
    "Book Appointment": "약속 예약",
    "Available Times": "사용 가능한 시간",
    "No slots available": "사용 가능한 슬롯 없음",
    "Schedule Appointment": "약속 예약",
    "Available Meeting Types": "사용 가능한 회의 유형",
    "Please select a meeting type to view availability.": "가용성을 확인하려면 회의 유형을 선택하십시오.",
    "All": "전체",
    "No public events found.": "공개 이벤트를 찾을 수 없습니다.",
    "Timezone": "시간대",
    "Privacy & Terms": "개인정보 및 약관",
    "Quick": "빠른",
    "Consulting": "상담",
    "Tags": "태그",
    "Type a tag and press Enter": "태그를 입력하고 Enter를 누르세요",
    "Press Enter to add a tag": "Enter를 눌러 태그 추가",
    "Cancel": "취소",
    "landing_hero_title": "약속 관리 <span class=\"text-primary\">쉬어짐</span>",
    "landing_hero_subtitle": "Appoint Me는 약속을 위한 간단하고 사용자 친화적인 솔루션입니다. 이벤트를 만들고 링크를 공유하여 다른 사람들이 귀하와 약속을 예약할 수 있도록 하세요.",
    "landing_cta_start": "지금 시작하기",
    "landing_cta_learn_more": "더 알아보기",
    "landing_how_it_works_title": "Appoint Me 작동 방식",
    "landing_how_it_works_subtitle": "단 4단계만으로 정리된 캘린더를 만들 수 있습니다.",
    "landing_step1_title": "1. 캘린더 구성",
    "landing_step1_desc": "Appoint Me가 약속을 입력해야 하는 곳과 가용성을 확인해야 하는 곳을 결정합니다. Google 또는 Outlook 캘린더를 연결하세요.",
    "landing_step2_title": "2. 이벤트 만들기",
    "landing_step2_desc": "사용 가능한 시간을 추가하고 지속 시간과 휴식 시간을 정의한 다음 시작하세요!",
    "landing_step3_title": "3. 링크 공유",
    "landing_step3_desc": "개인 링크를 통해 고객, 동료 또는 친구가 성가신 이메일 핑퐁 없이 직접 약속을 예약할 수 있습니다.",
    "landing_step4_title": "완료! 축하합니다!",
    "landing_step4_desc": "사용자가 약속을 예약하면 이벤트가 자동으로 캘린더에 추가되고 두 사람 모두 확인을 받습니다.",
    "landing_footer_product": "제품",
    "landing_footer_features": "기능",
    "landing_footer_pricing": "가격",
    "landing_footer_integrations": "통합",
    "landing_footer_resources": "리소스",
    "landing_footer_documentation": "문서",
    "landing_footer_api": "API",
    "landing_footer_help_center": "도움말 센터",
    "landing_footer_legal": "법적 고지",
    "landing_footer_imprint": "법적 고지",
    "landing_footer_privacy": "개인정보 보호",
    "landing_footer_terms": "약관 및 조건",
    "landing_footer_copyright": COPYRIGHT_ENGLISH,
    "landing_footer_tagline": "모두를 위한 간단한 약속 계획.",
    "Contact": "연락처",
    "footer_credits": "South Westphalia University of Applied Sciences에서 ❤️로 구현됨",
    "terms_of_use_title": "이용 약관",
    "terms_of_use_content": "# 이용 약관\n\n## 서비스 제공\n\n이 서비스는 무료로 제공됩니다.\n\n## 책임 및 보증 부인\n\n저자나 South Westphalia University of Applied Sciences는 이 서비스 사용과 관련하여 어떠한 종류의 손해에 대해서도 책임을 지지 않으며 어떠한 종류의 보증도 하지 않습니다. 사용에 대한 책임은 귀하에게 있습니다. 이 부인은 의도적이거나 태만한 의무 위반으로 인한 생명, 신체 또는 건강상의 상해로 인한 손해에는 적용되지 않으며, 의도적이거나 중대한 과실로 인한 의무 위반으로 인한 기타 손해에도 적용되지 않습니다.",
    "my_appointments": "내 약속",
    "no_upcoming_appointments": "다가오는 약속을 찾을 수 없습니다.",
    "appointment": "약속",
    "attendee": "참석자",
    "appointment_details": "약속 세부 정보",
    "close": "닫기",
    "event_type": "이벤트 유형",
    "week": "주",
    "work_week": "근무 주",
    "day": "일",
    "month": "월",
    "today": "오늘",
    "agenda": "안건",
    "more": "더보기",
    "next": "다음",
    "back": "뒤로",
    "n_more": "{{count}}개 더 ...",
    "Recurrence": "반복",
    "Enable Recurring Event": "반복 이벤트 활성화",
    "Frequency": "빈도",
    "Weekly": "매주",
    "Bi-weekly": "격주",
    "Tri-weekly": "3주마다",
    "Monthly": "매월",
    "End Condition": "종료 조건",
    "Occurrences": "횟수",
    "OR": "또는",
    "Until Date": "종료 날짜",
    "Time Span": "기간",
    "Months": "개월",
    "Weeks": "주",
    "Recurring Event": "반복 이벤트",
    "Recurring": "반복",
    "weekly": "매주",
    "biweekly": "격주",
    "triweekly": "3주마다",
    "monthly": "매월",
    "Series Booking Note: Students will book all occurrences at once.": "연속 예약 참고: 학생들은 모든 일정을 한 번에 예약합니다.",
    "Feedback": "피드백",
    "Student Only": "학생 전용",
    "Restricted to Students": "학생으로 제한됨",
    "Settings exported successfully": "설정이 성공적으로 내보내졌습니다",
    "Failed to export settings": "설정 내보내기 실패",
    "Are you sure you want to import settings? This will overwrite your current profile and events.": "설정을 가져오시겠습니까? 현재 프로필과 이벤트가 덮어쓰여집니다.",
    "Settings imported successfully": "설정이 성공적으로 가져와졌습니다",
    "Failed to import settings": "설정 가져오기 실패",
    "Invalid file format": "잘못된 파일 형식",
    "Data": "데이터",
    "Export Settings": "설정 내보내기",
    "Download your settings and events as a JSON file.": "설정 및 이벤트를 JSON 파일로 다운로드합니다.",
    "Export Data": "데이터 내보내기",
    "Import Settings": "설정 가져오기",
    "Restore your settings from a JSON file. This will overwrite existing data.": "JSON 파일에서 설정을 복원합니다. 기존 데이터를 덮어씁니다.",
    "Select File": "파일 선택",
    "Online Meeting": "온라인 회의",
    "You are logged in via your Learning Management System. Please use the specific booking links provided in your course to book appointments.": "학습 관리 시스템을 통해 로그인했습니다. 약속을 예약하려면 과정에서 제공된 특정 예약 링크를 사용하십시오.",
    "Logout": "로그아웃",
    "MyProvider": "내 공급자",
    "Grammatical Gender": "문법적 성",
    "Male": "남성",
    "Female": "여성",
    "Neuter": "중성",
    "gender_help_text": "확인 메시지에서 올바른 문법을 사용하는 데 사용됩니다.",
    "Changelog": "Changelog",
    "Failed to load changelog data.": "변경 로그 데이터를 불러오지 못했습니다.",
    "See what's new and what has been fixed.": "새로운 기능과 수정 사항을 확인하세요.",
    "Reminder setting": "알림 설정",
    "Notification type": "알림 유형",
    "System notification": "시스템 알림",
    "No reminder": "알림 없음",
    "Reminder time": "알림 시간",
    "Reminder settings saved": "알림 설정이 저장되었습니다",
    "At event start": "이벤트 시작 시",
    "minutes before": "분 전",
    "1 day before": "1일 전",
    "days before": "일 전",
    "1 hour before": "1시간 전",
    "hours before": "시간 전"
};
//# sourceMappingURL=ko.js.map